export enum PurchaseStatus {
  Created = 1,
  Cancelled = 2,
  Failed = 3,
  Partial = 4,
  Completed = 5,
  Refunded = 6,
  CalledBack = 7,
  CalledBackFailed = 8,
  RequireMoreInformation = 9,
  RefundedByCustomer = 10
}
